<script setup>
function toApply() {
  window.open(
    'https://cdn.isc.360.com/iscvideo-bucket/ISC2023_2023_Sponsor_Plan_0522.pdf',
    '_self '
  )
}
</script>

<template>
  <div class="membership">
    <img src="https://p0.ssl.qhimg.com/t01d4e9d864bef9f527.jpg" alt="" class="membershipBgc" />
    <div class="membershipNav">
      <img src="https://p0.ssl.qhimg.com/t014b570ecda2fc846d.jpg" alt="内容" />
      <div class="membershipBtn" @click="toApply">点击下载商务合作方案</div>
      <div class="membershipText">
        <p>ISC商务总监：马欣15718876610</p>
        <p>获取早鸟折扣 重磅权益提前锁定！</p>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.membership {
  position: relative;
  min-width: 1200px;
  &Bgc {
    position: fixed;
    top: 0;
    width: 100%;
    min-width: 1200px;
  }
  &Nav {
    text-align: center;
    background-color: #fff;
    position: absolute;
    top: 858px;
    left: 50%;
    transform: translateX(-50%);
  }
  &Btn {
    cursor: pointer;
    width: 600px;
    height: 100px;
    line-height: 100px;
    margin: 51px auto 81px;
    color: #fff;
    font-size: 36px;
    font-weight: bold;
    background: #1833ff;
    box-shadow: 0px 6px 20px 0px rgba(24, 127, 255, 0.5);
    border-radius: 50px;
  }
  &Text {
    color: #1b1b1b;
    line-height: 80px;
    margin: 0 auto 590px;
    p:first-child {
      font-size: 48px;
    }
    p:last-child {
      font-size: 30px;
    }
  }
}
</style>
